import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { Modal, Button, Form, Row, Col, Badge } from 'react-bootstrap';
import { activityStore } from '../stores/ActivityStore';
import { inventoryStore } from '../stores/InventoryStore';
import { batchStore } from '../stores/BatchStore';
import { userStore } from '../stores/UserStore';
const SessionFilterDialog = observer(({ show, onHide, onApply, onClear, type, initialFilters }) => {
    const [filters, setFilters] = useState({
        title: initialFilters.title || '',
        coachIds: initialFilters.coachIds || [],
        activityIds: initialFilters.activityIds || [],
        inventoryIds: initialFilters.inventoryIds || [],
        batchIds: initialFilters.batchIds || [],
        playerIds: initialFilters.playerIds || []
    });
    useEffect(() => {
        setFilters({
            title: initialFilters.title || '',
            coachIds: initialFilters.coachIds || [],
            activityIds: initialFilters.activityIds || [],
            inventoryIds: initialFilters.inventoryIds || [],
            batchIds: initialFilters.batchIds || [],
            playerIds: initialFilters.playerIds || []
        });
    }, [initialFilters, show]);
    const handleApply = () => {
        const activeFilters = {};
        if (filters.title && type === 'template') {
            activeFilters.title = filters.title;
        }
        if (filters.coachIds.length > 0) {
            activeFilters.coachIds = filters.coachIds;
        }
        if (filters.activityIds.length > 0) {
            activeFilters.activityIds = filters.activityIds;
        }
        if (filters.inventoryIds.length > 0) {
            activeFilters.inventoryIds = filters.inventoryIds;
        }
        if (filters.batchIds.length > 0) {
            activeFilters.batchIds = filters.batchIds;
        }
        if (filters.playerIds.length > 0 && type === 'template') {
            activeFilters.playerIds = filters.playerIds;
        }
        onApply(activeFilters);
        onHide();
    };
    const handleClear = () => {
        setFilters({
            title: '',
            coachIds: [],
            activityIds: [],
            inventoryIds: [],
            batchIds: [],
            playerIds: []
        });
        onClear();
        onHide();
    };
    const getActiveFilterCount = () => {
        let count = 0;
        if (filters.title && type === 'template')
            count++;
        if (filters.coachIds.length > 0)
            count++;
        if (filters.activityIds.length > 0)
            count++;
        if (filters.inventoryIds.length > 0)
            count++;
        if (filters.batchIds.length > 0)
            count++;
        if (filters.playerIds.length > 0 && type === 'template')
            count++;
        return count;
    };
    return (_jsxs(Modal, { show: show, onHide: onHide, size: "lg", children: [_jsx(Modal.Header, { closeButton: true, children: _jsxs(Modal.Title, { children: ["Filter ", type === 'template' ? 'Templates' : 'Sessions', getActiveFilterCount() > 0 && (_jsx(Badge, { bg: "primary", className: "ms-2", children: getActiveFilterCount() }))] }) }), _jsx(Modal.Body, { children: _jsxs(Row, { children: [type === 'template' && (_jsx(Col, { md: 12, children: _jsxs(Form.Group, { className: "mb-3", children: [_jsx(Form.Label, { children: "Title" }), _jsx(Form.Control, { type: "text", value: filters.title, onChange: (e) => setFilters({ ...filters, title: e.target.value }), placeholder: "Search by title" })] }) })), _jsx(Col, { md: 6, children: _jsxs(Form.Group, { className: "mb-3", children: [_jsx(Form.Label, { children: "Coaches" }), _jsx(Form.Select, { multiple: true, value: filters.coachIds, onChange: (e) => {
                                            const selected = Array.from(e.target.selectedOptions, option => option.value);
                                            setFilters({ ...filters, coachIds: selected });
                                        }, style: { height: '120px' }, children: userStore.users.filter(u => u.roles.includes('coach')).map(user => (_jsx("option", { value: user.id, children: user.name }, user.id))) }), _jsx(Form.Text, { className: "text-muted", children: "Hold Ctrl/Cmd to select multiple" })] }) }), type === 'template' && (_jsx(Col, { md: 6, children: _jsxs(Form.Group, { className: "mb-3", children: [_jsx(Form.Label, { children: "Players" }), _jsx(Form.Select, { multiple: true, value: filters.playerIds, onChange: (e) => {
                                            const selected = Array.from(e.target.selectedOptions, option => option.value);
                                            setFilters({ ...filters, playerIds: selected });
                                        }, style: { height: '120px' }, children: userStore.users.filter(u => u.roles.includes('player')).map(user => (_jsx("option", { value: user.id, children: user.name }, user.id))) }), _jsx(Form.Text, { className: "text-muted", children: "Hold Ctrl/Cmd to select multiple" })] }) })), _jsx(Col, { md: 6, children: _jsxs(Form.Group, { className: "mb-3", children: [_jsx(Form.Label, { children: "Activities" }), _jsx(Form.Select, { multiple: true, value: filters.activityIds, onChange: (e) => {
                                            const selected = Array.from(e.target.selectedOptions, option => option.value);
                                            setFilters({ ...filters, activityIds: selected });
                                        }, style: { height: '120px' }, children: activityStore.activities.map(activity => (_jsx("option", { value: activity.id, children: activity.name }, activity.id))) }), _jsx(Form.Text, { className: "text-muted", children: "Hold Ctrl/Cmd to select multiple" })] }) }), _jsx(Col, { md: 6, children: _jsxs(Form.Group, { className: "mb-3", children: [_jsx(Form.Label, { children: "Inventories" }), _jsx(Form.Select, { multiple: true, value: filters.inventoryIds, onChange: (e) => {
                                            const selected = Array.from(e.target.selectedOptions, option => option.value);
                                            setFilters({ ...filters, inventoryIds: selected });
                                        }, style: { height: '120px' }, children: inventoryStore.inventories.filter(i => i.active).map(inventory => (_jsx("option", { value: inventory.id, children: inventory.name }, inventory.id))) }), _jsx(Form.Text, { className: "text-muted", children: "Hold Ctrl/Cmd to select multiple" })] }) }), _jsx(Col, { md: 12, children: _jsxs(Form.Group, { className: "mb-3", children: [_jsx(Form.Label, { children: "Batches" }), _jsx(Form.Select, { multiple: true, value: filters.batchIds, onChange: (e) => {
                                            const selected = Array.from(e.target.selectedOptions, option => option.value);
                                            setFilters({ ...filters, batchIds: selected });
                                        }, style: { height: '120px' }, children: batchStore.batches.map(batch => (_jsx("option", { value: batch.id, children: batch.name }, batch.id))) }), _jsx(Form.Text, { className: "text-muted", children: "Hold Ctrl/Cmd to select multiple" })] }) })] }) }), _jsxs(Modal.Footer, { children: [_jsx(Button, { variant: "outline-secondary", onClick: onHide, className: "btn-touch w-mobile-100", children: "Cancel" }), _jsx(Button, { variant: "outline-danger", onClick: handleClear, className: "btn-touch w-mobile-100", children: "Clear All" }), _jsx(Button, { variant: "primary", onClick: handleApply, className: "btn-touch w-mobile-100", children: "Apply Filters" })] })] }));
});
export default SessionFilterDialog;
